import { cn } from "@/lib/utils";

export default function ButtonSkeleton({
  className,
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn(className, "w-24 h-10 rounded-none")} />;
}
